var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettingGeneral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.81421 0.5L4.12843 2.13217C3.99127 2.17332 3.86783 2.2419 3.74439 2.31047L2.11222 1.62469L1.12469 2.61222L1.81047 4.24439C1.74189 4.38155 1.68703 4.49127 1.63217 4.62843L0 5.31421V6.68579L1.63217 7.37157C1.68703 7.50873 1.74189 7.61845 1.81047 7.75561L1.12469 9.38778L2.11222 10.3753L3.74439 9.68952C3.86783 9.74439 3.99127 9.81297 4.12843 9.86783L4.81421 11.5H6.18579L6.87157 9.86783C6.99501 9.81297 7.13217 9.7581 7.25561 9.68952L8.88778 10.3753L9.87531 9.38778L9.18953 7.75561C9.24439 7.63217 9.31297 7.49501 9.36783 7.37157L11 6.68579V5.31421L9.36783 4.62843C9.32668 4.50499 9.2581 4.36783 9.18953 4.24439L9.87531 2.61222L8.88778 1.62469L7.25561 2.31047C7.13217 2.25561 6.99501 2.18703 6.87157 2.13217L6.18579 0.5L4.81421 0.5ZM5.5 3.92893C6.6384 3.92893 7.55736 4.84788 7.55736 5.98628C7.55736 7.12469 6.6384 8.04364 5.5 8.04364C4.3616 8.04364 3.44264 7.12469 3.44264 5.98628C3.44264 4.84788 4.3616 3.92893 5.5 3.92893Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettingGeneral);
export default __webpack_public_path__ + "static/media/icon-setting-general.d38d41106a707954de5579e0f8c4f4fe.svg";
export { ForwardRef as ReactComponent };